import anti_air from '../assets/units/anti_air.png';
import artillery_battery from '../assets/units/artillery_battery.gif';
import artillery_tank from '../assets/units/artillery_tank.png';
import artillery_truck from '../assets/units/artillery_truck.png';
import beast_rider from '../assets/units/beast_rider.gif';
import beast from '../assets/units/beast.png';
import bomb from '../assets/units/bomb.png';
import fast_vehicle from '../assets/units/fast_vehicle.png';
import heavy_armoured_infantry from '../assets/units/heavy_armoured_infantry.webp';
import heavy_hover_tank from '../assets/units/heavy_hover_tank.png';
import heavy_tank from '../assets/units/heavy_tank.png';
import heavy_weapon_infantry from '../assets/units/heavy_weapon_infantry.png';
import fast_hover from '../assets/units/fast_hover.png';
import infantry from '../assets/units/infantry.png';
import jet_infantry from '../assets/units/jet_infantry.webp';
import light_infantry from '../assets/units/light_infantry.webp';
import light_tank from '../assets/units/light_tank.png';
import mid_tank from '../assets/units/mid_tank.png';
import mortar_infantry from '../assets/units/mortar_infantry.webp';
import rider from '../assets/units/rider.webp';
import tower from '../assets/units/tower.png';
import transport_hover from '../assets/units/transport_hover.png';
import transport_tank from '../assets/units/transport_tank.png';
import truck from '../assets/units/truck.png';
import walker_vehicle from '../assets/units/walker_vehicle.png';
import war_suit from '../assets/units/war_suit.gif';

export const unitsImages = {
  anti_air:anti_air,
  artillery_battery:artillery_battery,
  artillery_tank:artillery_tank,
  artillery_truck:artillery_truck,
  beast_rider:beast_rider,
  beast:beast,
  bomb:bomb,
  fast_vehicle:fast_vehicle,
  heavy_armoured_infantry:heavy_armoured_infantry,
  heavy_hover_tank:heavy_hover_tank,
  heavy_tank:heavy_tank,
  heavy_weapon_infantry:heavy_weapon_infantry,
  fast_hover:fast_hover,
  infantry:infantry,
  jet_infantry:jet_infantry,
  light_infantry:light_infantry,
  transport_armoured_tank:light_tank,
  mid_tank:mid_tank,
  mortar_infantry:mortar_infantry,
  rider:rider,
  tower:tower,
  transport_hover:transport_hover,
  transport_tank:transport_tank,
  truck:truck,
  walker_vehicle:walker_vehicle,
  war_suit:war_suit,
  }